import React from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import KuterLogo from '../../../../Images/footer/logo_kuter.png';
import MailIcon from '../../../../Images/icons/mail-icon.png';
import CreateIcon from '../../../../Images/icons/create-icon.png';
import JoinIcon from '../../../../Images/icons/join-icon.png';
import PracticeIcon from '../../../../Images/icons/practice-icon.png';

import {
  Cosult_Text,
  Create_Text,
  Join_Text,
  Practice_Text,
} from '../../../../utils/EN/Modals/ModalContact';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  max-width: 980px;
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16rem;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 350px;
  }
`;

const Logo = styled.img`
  width: 100%;
  height: auto;
  margin: 0 auto;
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-direction: column;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  p {
    text-decoration: underline;
    cursor: pointer;
    transition: 0.3s all ease-out;

    &:hover {
      text-shadow: 0px 0px 7px rgba(255, 255, 255, 0.9);
      -webkit-text-stroke: 1px rgba(255, 255, 255, 1);
    }
  }
`;

const Icon = styled.img`
  width: ${({ $width }) => $width || '54px'};
  height: auto;
`;

const ModalContact = () => {
  const { closeModal } = useModal();

  const { openModal } = useModal();

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  return (
    <Modal
      id="contact"
      bgColor={'rgba(0, 0, 0, 0.5)'}
      filter={'blur(16px)'}
      borderOut={'""'}
      padding={'80px 80px'}
      mobPadding={'50px'}
    >
      <CloseContainer>
        <CloseButton
          onClick={closeModal}
          aria-label="Close modal"
          src={CloseIcon}
        />
      </CloseContainer>
      <ModalContent>
        <Logo src={KuterLogo} alt="Kuter" />
        <InfoContainer>
          <InfoRow>
            <Icon src={MailIcon} alt="Icon Mail" />
            <RichText
              data-target="consult-form"
              onClick={handleClick}
              dataText={Cosult_Text}
            />
          </InfoRow>
          <InfoRow>
            <Icon $width={'58px'} src={CreateIcon} alt="Icon Mail" />
            <RichText
              data-target="create-form"
              onClick={handleClick}
              dataText={Create_Text}
            />
          </InfoRow>
          <InfoRow>
            <Icon $width={'53px'} src={JoinIcon} alt="Icon Mail" />
            <RichText
              data-target="join-form"
              onClick={handleClick}
              dataText={Join_Text}
            />
          </InfoRow>
          <InfoRow>
            <Icon $width={'61px'} src={PracticeIcon} alt="Icon Mail" />
            <RichText
              data-target="practic-form"
              onClick={handleClick}
              dataText={Practice_Text}
            />
          </InfoRow>
        </InfoContainer>
      </ModalContent>
    </Modal>
  );
};

export default ModalContact;
